import { useEffect, useState } from 'react';
import StepFrame from './StepFrame.js';
import Requests from '../Requests.js';
import Theme from '../styles/Theme.js';

/*
 * LookupStep
 *
 * Not a question, a pause while we check whether we already know this person.
 * It is the only step nobody answers, so it renders as a held breath and moves
 * on by itself.
 *
 * A FAILURE IS NOT SHOWN. If the lookup errors we are in exactly the position
 * we are in when the customer has no record: we do not know their dealership, so we
 * ask for the address and route to the home office. Putting an error screen in
 * front of somebody with a fire system problem, over an internal service they
 * did not know existed and cannot do anything about, would trade a working
 * fallback for a dead end. It is logged, not surfaced.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LookupStep = ({
  answers,
  onResult,
  stepKey
}) => {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    let cancelled = false;

    // Only after a beat, so a fast lookup never flashes a message.
    let timer = setTimeout(() => !cancelled && setSlow(true), 2500);
    Requests.lookup({
      email_address: answers.email_address,
      phone_number: answers.phone_number
    }).catch(e => {
      console.error(`[SupportCenter] customer lookup failed: ${e.message}`);
      return {
        dealership: null
      };
    }).then(result => !cancelled && onResult(result));
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // Keyed on the node, deliberately. A new callback identity on re-render
    // must not fire a second lookup for the same customer.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepKey]);
  return /*#__PURE__*/_jsx(StepFrame, {
    help: 'One moment while we look up your account.',
    stepKey: stepKey,
    title: 'Checking your details',
    children: /*#__PURE__*/_jsxs("div", {
      "aria-busy": true,
      role: 'status',
      children: [[64, 40, 52].map((width, index) => /*#__PURE__*/_jsx("div", {
        className: 'support-skeleton',
        style: {
          height: 14,
          marginBottom: 12,
          width: `${width}%`
        }
      }, index)), /*#__PURE__*/_jsx("span", {
        style: {
          ...Theme.textStyles.caption(),
          display: 'block',
          marginTop: 18,
          opacity: slow ? 1 : 0,
          transition: 'opacity 0.3s ease'
        },
        children: 'Still checking. This will only take a moment longer.'
      })]
    })
  });
};
export default LookupStep;